import { useState } from 'react'
import { ConfirmationModal } from 'components/organisms/modals/confirmation-modal'

export interface GuestListFormatModalProps {
	open: boolean
	setOpen: (open: boolean) => void
}

const GUEST_LIST_TEMPLATE_URL = '/document-templates/guest-list-template.csv'

export function GuestListFormatModal({ open, setOpen }: GuestListFormatModalProps) {
	return (
		<ConfirmationModal title="CSV Format" open={open} setOpen={setOpen} hideCloseButton={false}>
			<div>
				<div className="mb-8">Click below to download a sample format for your guest list</div>
				<div className="space-y-2">
					<a
						type="button"
						className="px-6 rounded-3xl text-center transition-all duration-300 bg-primary text-white font-bold w-full h-12 shadow-button backdrop-blur-lg hover:bg-primary-hover disabled:bg-white/10 disabled:text-white-25 disabled:shadow-none flex items-center justify-center"
						href={GUEST_LIST_TEMPLATE_URL}
						download
						target="_blank"
						rel="noreferrer"
					>
						Download
					</a>
				</div>
			</div>
		</ConfirmationModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export type GuestListFormatModalManagedProps = Record<string, unknown>

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'guest-list-format': GuestListFormatModalManagedProps
	}
}

export function ManagedGuestListFormatModal({
	onClose,
}: GuestListFormatModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<GuestListFormatModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
		/>
	)
}
